import {
  Col,
  Row,
  Space,
  Table,
  Tag,
  Card,
  Button,
  message,
  Spin,
  Tooltip,
  Select,
  Typography,
  Input,
} from "antd";
import React, { useEffect, useMemo, useState } from "react";
import DetailModal from "../detail/DetailModal";
import {
  EditOutlined,
  FormOutlined,
  PrinterOutlined,
  CheckCircleOutlined,
  CloseCircleOutlined,
  SyncOutlined,
  ReloadOutlined,
  SearchOutlined,
  DownSquareOutlined,
  UpSquareOutlined,
} from "@ant-design/icons";
import MotionHoc from "../../../utils/MotionHoc";
import { Link } from "react-router-dom";
import {
  baseUrl,
  GET_JOB_IN_PROGRESS_BY_STATUS,
  HEADERS_EXPORT,
} from "../../API/apiUrls";
import ExcelJS from "exceljs";
import { saveAs } from "file-saver";
import axios from "axios";
import DateCustom from "../../../hook/DateCustom";
import {
  ENFORCEMENT,
  STATUS_PROCESS_PROCESS,
  STATUS_PROCESS_PROCESS_PAYMENT,
  STATUS_PROCESS_PROGRESS,
  STATUS_PROCESS_SUCCESSFUL,
} from "../../../utils/constant/StatusConstant";
import dayjs from "dayjs";
import ReportSeize from "./modal/ReportSeize";
import EditJudgement from "./modal/EditJudgement";
import { optionsLocat } from "../../../utils/constant/LocatOption";
import { ThaiRangePicker } from "../../../hook/ThaiDatePickerNew";

const Main = () => {
  const [
    convertDateThai,
    convertDateThaiShort,
    convertDateThaiYear,
    convertDateThaiMonth,
    convertDateThaiDate,
    dateNow,
  ] = DateCustom();
  const { Option } = Select;
  const [isModal, setIsModal] = useState(false);
  const [isModalCreate, setIsModalCreate] = useState(false);
  const [isModalEdit, setIsModalEdit] = useState(false);
  const [arrayTable, setArrayTable] = useState();
  const [dataArr, setDataArr] = useState();
  const [loading, setLoading] = useState();
  const [tableLength, setTableLength] = useState(0);
  const [dataRecord, setDataRecord] = useState();
  const ROLE_ID = localStorage.getItem("ROLE_ID");
  const userId = parseInt(localStorage.getItem("USER_ID"));
  const userCompany = localStorage.getItem("COMPANY_ID");
  const [arrow, setArrow] = useState("Show");
  const [expandedRowKeys, setExpandedRowKeys] = useState([]);
  const [statusId, setStatusId] = useState();
  const [statusAction, setStatusAction] = useState();
  const [datePickerInvestigate, setDatePickerInvestigate] = useState();
  const [searchInput, setSearchInput] = useState();
  const [advanceSearch, setAdvanceSearch] = useState(false);
  const [datePickerJudge, setDatePickerJudge] = useState();
  const toggle = () => setAdvanceSearch((v) => !v);

  const renderOpteionStatus = () => {
    return (
      <>
        <Option value={1}>
          <span style={{ marginRight: 8 }}>🗂️</span>
          ทั้งหมด
        </Option>
        <Option value={2}>
          <CloseCircleOutlined style={{ color: "red", marginRight: 8 }} />
          ไม่เจอทรัพย์
        </Option>
        <Option value={3}>
          <CheckCircleOutlined style={{ color: "green", marginRight: 8 }} />{" "}
          เจอทรัพย์
        </Option>
        <Option value={4}>
          <span style={{ marginRight: 8 }}>⏳</span>
          รอสร้างรายการยึด
        </Option>
        <Option value={5}>
          <span style={{ marginRight: 8 }}>📝</span>
          รอบันทึกการยึด
        </Option>
        <Option value={6}>
          <span style={{ marginRight: 8 }}>✅</span>
          บันทึกสำเร็จ
        </Option>
      </>
    );
  };

  useEffect(() => {
    loadData();
  }, []);

  const loadData = async (data) => {
    setLoading(true);
    console.log(data);
    try {
      const response = await axios.get(
        baseUrl + GET_JOB_IN_PROGRESS_BY_STATUS + ENFORCEMENT,
        {
          headers: HEADERS_EXPORT,
        }
      );
      if (response.data) {
        let i = 1;
        if (response.data) {
          const newData = response.data.map((item) => ({
            ...item,
            key: i++,
          }));
          filterDataLawyer(newData);
          console.log(newData);

          setLoading(false);
        }
      } else {
        setArrayTable([]);
      }
    } catch (error) {
      console.error(
        "Error posting data:",
        error.response ? error.response.data : error.message
      );
      setLoading(false);
      message.error(`ไม่พบข้อมูล: ${error.message}`);
    }
  };

  const onExpand = (expanded, record) => {
    if (expanded) {
      // เมื่อแถวถูกขยาย, ให้เพิ่ม key ของแถวนั้นลงใน expandedRowKeys
      setExpandedRowKeys([record.key]);
    } else {
      // เมื่อแถวถูกยุบ, ให้ลบ key ของแถวนั้นออกจาก expandedRowKeys
      setExpandedRowKeys([]);
    }
  };

  const mergedArrow = useMemo(() => {
    if (arrow === "Hide") {
      return false;
    }
    if (arrow === "Show") {
      return true;
    }
    return {
      pointAtCenter: true,
    };
  }, [arrow]);

  const filterDataLawyer = (data) => {
    if (Array.isArray(data)) {
      const newData = data.filter(
        (item) =>
          (ROLE_ID === "3" ||
            ROLE_ID === "4" ||
            ROLE_ID === "1" ||
            ROLE_ID === "2" ||
            ROLE_ID === "9") &&
          (item.PROCESS_ID === STATUS_PROCESS_PROGRESS ||
            item.PROCESS_ID === STATUS_PROCESS_PROCESS ||
            item.PROCESS_ID === STATUS_PROCESS_PROCESS_PAYMENT ||
            item.PROCESS_ID === STATUS_PROCESS_SUCCESSFUL) &&
          // &&
          // (item?.customer_property_list?.length > 0 ||
          //   item?.guarantor_property_list?.length > 0)
          item.judge_date
      );

      let filteredData;

      if (userCompany === "3") {
        filteredData = newData.filter((item) => {
          const branch = item.LOCAT;
          // ถ้า branch เป็น null หรือ undefined ให้ return true ไปเลย (หรือ false ก็ได้ ขึ้นกับความต้องการ)
          if (!branch) return true; // หรือ false ก็ได้ ถ้าอยาก "กรองออก"
          return (
            !optionsLocat.some((opt) => branch.includes(opt.label)) ||
            item.CONTNO.includes("UD")
          );
        });
      } else {
        filteredData = newData.filter((item) => {
          const branch = item.LOCAT;
          if (!branch) return false; // ไม่มี branch ไม่ผ่านเงื่อนไข

          return optionsLocat.some((opt) => branch.includes(opt.label));
        });
      }

      const sortedData = filteredData.sort((a, b) => {
        // ถ้า a ไม่มี judge_date ให้เอาไว้ล่าง
        if (!a.judge_date && b.judge_date) return 1;
        // ถ้า b ไม่มี judge_date ให้เอาไว้ล่าง
        if (a.judge_date && !b.judge_date) return -1;
        // ถ้าทั้งคู่มี judge_date ให้เปรียบเทียบปกติ (ล่าสุดก่อน)
        if (a.judge_date && b.judge_date) {
          return new Date(a.judge_date) - new Date(b.judge_date);
        }
        return 0; // ถ้าทั้งคู่เป็น null
      });

      setArrayTable(sortedData);
      setDataArr(filteredData);
      setTableLength(sortedData.length);
      console.log("filteredData", sortedData);
      console.log("Length of filtered data:", sortedData.length);
    } else {
      console.error("data is not an array or is undefined");
      setTableLength(0);
    }
  };

  const search = (event) => {
    console.log("query--->", event.target.value);
    setSearchInput(event.target.value);
  };

  const handleUpdateData = (data) => {
    console.log("data---->update", data);
    setExpandedRowKeys([]);
    loadData();
    // if (data !== 0) {
    //   const result = dataArr.map((item) => {
    //     if (item.id === data.id) {
    //       return { ...data };
    //     } else {
    //       return { ...item };
    //     }
    //   });
    //   console.log(result);
    //   setDataArr(result);
    //   const arr = result.filter(
    //     (item) =>
    //       (item.LAWYER_ID === userId || ROLE_ID === "1" || ROLE_ID === "2") &&
    //       item.MAIN_STATUS_ID === item.STATUS_ID
    //   );
    //   console.log("arr", arr);
    // } else {
    //   loadData();
    //   console.log("handleUpdateData loadData");
    // }
  };

  const createAndDownloadExcel = async () => {
    const workbook = new ExcelJS.Workbook();
    const currentYear = dayjs().year();

    // แยกข้อมูลตามปีของ judge_date
    const groupedByYear = {};

    (arrayTable || []).forEach((data) => {
      const year = dayjs(data.judge_date).year(); // แยกปี
      if (!groupedByYear[year]) groupedByYear[year] = [];
      groupedByYear[year].push(data);
    });

    Object.entries(groupedByYear).forEach(([year, records]) => {
      const yearDiff = currentYear - parseInt(year, 10);
      const worksheet = workbook.addWorksheet(
        `ปี ${year} (${yearDiff} ปีที่แล้ว)`
      );

      worksheet.columns = [
        { header: "ลำดับ", key: "no", width: 10 },
        { header: "เลขสัญญา", key: "contno", width: 15 },
        { header: "ชื่อ-นามสกุล", key: "fullname", width: 30 },
        { header: "วันที่พิพากษา", key: "judge_date", width: 15 },
        { header: "จำนวนวัน", key: "days", width: 20 },
        { header: "เลขคดีแดง", key: "red_case_number", width: 20 },
        { header: "เจ้าของคดี", key: "lawyer", width: 20 },
      ];

      records.forEach((data, index) => {
        worksheet.addRow([
          index + 1,
          data.CONTNO,
          `${data.CUSTOMER_TNAME} ${data.CUSTOMER_FNAME} ${data.CUSTOMER_LNAME}`,
          convertDateThai(data.judge_date),
          renderDate(data.judge_date),
          data.red_case_number || "-",
          data.LAWYER_NNAME,
        ]);
      });

      worksheet.eachRow((row) => {
        row.eachCell((cell) => {
          cell.alignment = { vertical: "middle", horizontal: "center" };
        });
      });
    });

    // สร้างไฟล์ Excel
    const buffer = await workbook.xlsx.writeBuffer();
    const blob = new Blob([buffer], {
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    });

    saveAs(blob, `รายงานอายุความแยกตามปี_${dayjs().format("YYYY_MM_DD")}.xlsx`);
  };

  //ทำ render record ของตาราถ้าใช้ logic เยอะ
  const renderDate = (record) => {
    //ส่งค่า null ออกไปถ้า record นี่ยังไม่มี
    if (!record) {
      return null;
    }
    const recordDate = dayjs(record);
    const today = dayjs().startOf("day");

    // คำนวณความแตกต่างในหน่วยปี
    const yearsDifference = today.diff(recordDate, "year");

    // คำนวณความแตกต่างในหน่วยเดือน
    const monthsDifference = today.diff(recordDate, "month");

    // คำนวณความแตกต่างในหน่วยวัน
    const daysDifference = today.diff(recordDate, "day");

    // คำนวณส่วนที่เหลือหลังจากคำนวณปีแล้ว (คำนวณเดือนที่เหลือ)
    const remainingMonths = today
      .subtract(yearsDifference, "year")
      .diff(recordDate, "month");

    // คำนวณส่วนที่เหลือหลังจากคำนวณปีและเดือนแล้ว (คำนวณวันที่เหลือ)
    const remainingDays = today
      .subtract(yearsDifference, "year")
      .subtract(remainingMonths, "month")
      .diff(recordDate, "day");

    return `${yearsDifference} ปี ${remainingMonths} เดือน ${remainingDays} วัน`;
  };

  const renderDateJudge = (record) => {
    //ส่งค่า null ออกไปถ้า record นี่ยังไม่มี
    if (!record.judge_date) {
      return null;
    }
    let color;
    const recordDate = dayjs(record.judge_date);
    const today = dayjs().startOf("day");

    // คำนวณความแตกต่างในหน่วยปี
    const yearsDifference = today.diff(recordDate, "year");

    // คำนวณความแตกต่างในหน่วยเดือน
    const monthsDifference = today.diff(recordDate, "month");

    // คำนวณความแตกต่างในหน่วยวัน
    const daysDifference = today.diff(recordDate, "day");

    // คำนวณส่วนที่เหลือหลังจากคำนวณปีแล้ว (คำนวณเดือนที่เหลือ)
    const remainingMonths = today
      .subtract(yearsDifference, "year")
      .diff(recordDate, "month");

    // คำนวณส่วนที่เหลือหลังจากคำนวณปีและเดือนแล้ว (คำนวณวันที่เหลือ)
    const remainingDays = today
      .subtract(yearsDifference, "year")
      .subtract(remainingMonths, "month")
      .diff(recordDate, "day");

    if (remainingMonths >= 1 || yearsDifference > 0) {
      color = "orange";
    } else if (remainingMonths < 1) {
      color = "blue";
    } else if (remainingMonths > 12) {
      color = "red";
    }

    const formattedDate = record.judge_date
      ? convertDateThai(recordDate)
      : null;
    return (
      <Tag color={color} key={daysDifference} style={{ textAlign: "center" }}>
        {formattedDate}
        <br />
        {
          <span>
            {yearsDifference} ปี {remainingMonths} เดือน {remainingDays} วัน
          </span>
        }
        {<p style={{ color: "red" }}>{record.red_case_number}</p>}
      </Tag>
    );
  };

  const renderInvestigate = (record) => {
    let color;
    if (
      record.customer_property_list?.length > 0 ||
      record.guarantor_property_list?.length > 0
    ) {
      color = "green";
    } else {
      color = "red";
    }

    return (
      <Tag color={color} style={{ textAlign: "center" }}>
        {record.customer_property_list?.length > 0 ||
        record.guarantor_property_list?.length > 0
          ? "เจอทรัพย์"
          : "ไม่เจอทรัพย์"}
        <br />
      </Tag>
    );
  };

  const renderProcessStatus = (record) => {
    let color;
    if (
      record.PROCESS_ID === 1 &&
      (record.customer_property_list?.length > 0 ||
        record.guarantor_property_list?.length > 0)
    ) {
      color = "red";
    } else if (record.PROCESS_ID === 4 || record.PROCESS_ID === 5) {
      color = "blue";
    } else if (
      record.PROCESS_ID === 3 &&
      (record.customer_property_list?.length > 0 ||
        record.guarantor_property_list?.length > 0)
    ) {
      color = "green";
    } else {
      return null;
    }

    return (
      <Tag color={color} style={{ textAlign: "center" }}>
        {record.PROCESS_ID === 1 &&
        (record.customer_property_list?.length > 0 ||
          record.guarantor_property_list?.length > 0)
          ? "รอดำเนินการยึด"
          : record.PROCESS_ID === 4 || record.PROCESS_ID === 5
          ? "รอบันทึกการยึด"
          : record.PROCESS_ID === 3 &&
            (record.customer_property_list?.length > 0 ||
              record.guarantor_property_list?.length > 0)
          ? "บันทึกสำเร็จ"
          : null}
        <br />
      </Tag>
    );
  };

  const onChangeSelectStatus = (value) => {
    console.log("onChangeSelectStatus-->", value);
    setStatusId(value);
  };

  const onChangeJudgeDate = (dates) => {
    setDatePickerJudge(dates);
  };

  const onChangeInvestigateDate = (dates) => {
    setDatePickerJudge(null);
    setDatePickerInvestigate(dates);
  };

  const renderDateInvestiGateAsset = (data = {}) => {
    // แสดงวันแบบพ.ศ.
    const fmt = (d) =>
      d && d.isValid() ? d.add(543, "year").format("D MMM YYYY") : null;

    // คืน dayjs ของ "วันที่เจอล่าสุด" หรือ null
    const latestBy = (list = [], field = "investigation_date") => {
      const arr = (list ?? [])
        .map((r) => dayjs(r?.[field]))
        .filter((d) => d.isValid())
        .sort((a, b) => b.valueOf() - a.valueOf());
      return arr[0] || null;
    };

    // หาความต่างเป็น ปี/เดือน/วัน (ตัดเวลา)
    const diffYMD = (from, to = dayjs()) => {
      if (!from || !from.isValid()) return null;
      const start = from.startOf("day");
      const end = dayjs(to).startOf("day");

      const years = end.diff(start, "year");
      const months = end.diff(start.add(years, "year"), "month");
      const days = end.diff(
        start.add(years, "year").add(months, "month"),
        "day"
      );
      return { years, months, days };
    };

    // ล่าสุดของลูกค้า/ผู้ค้ำ แล้วเลือกอันใหม่กว่า
    const custLatest = latestBy(data.customer_property_list);
    const guarLatest = latestBy(data.guarantor_property_list);
    if (!custLatest && !guarLatest) return null;

    const chosen =
      custLatest && (!guarLatest || custLatest.isAfter(guarLatest))
        ? custLatest
        : guarLatest;

    const span = diffYMD(chosen);
    const human = span
      ? `${span.years} ปี ${span.months} เดือน ${span.days} วัน`
      : "-";

    return (
      <Tag color="green" style={{ textAlign: "center" }}>
        {fmt(chosen)}
        <br />
        {human}
      </Tag>
    );
  };

  const onQueryData = () => {
    let result = [...dataArr];

    // helpers
    const inRange = (d, start, end) => {
      if (!d) return false;
      // รองรับทั้ง 'YYYY-MM-DD' และ ISO string
      const t = dayjs(d).startOf("day").valueOf();
      return t >= start && t <= end;
    };

    const hasInvestigationInRange = (list, start, end) =>
      Array.isArray(list) &&
      list.some((x) => inRange(x?.investigation_date, start, end));

    if (searchInput && searchInput.trim() !== "") {
      result = result.filter(
        (item) =>
          item?.CONTNO?.includes(searchInput.trim()) ||
          item?.CUSTOMER_LNAME?.includes(searchInput.trim()) ||
          item?.CUSTOMER_FNAME?.includes(searchInput.trim()) ||
          item?.red_case_number?.includes(searchInput.trim())
      );
    }

    // -----------------
    // Filter จาก Status
    // -----------------
    if (statusId) {
      if (statusId === 3) {
        // มีทรัพย์สิน (customer หรือ guarantor)
        result = result.filter(
          (item) =>
            (item.customer_property_list?.length > 0 ||
              item.guarantor_property_list?.length > 0) &&
            (ROLE_ID === "3" ||
              ROLE_ID === "4" ||
              ROLE_ID === "1" ||
              ROLE_ID === "2" ||
              ROLE_ID === "9")
        );
      } else if (statusId === 2) {
        // ไม่มีทรัพย์สิน
        result = result.filter(
          (item) =>
            item.customer_property_list?.length === 0 &&
            item.guarantor_property_list?.length === 0 &&
            (ROLE_ID === "3" ||
              ROLE_ID === "4" ||
              ROLE_ID === "1" ||
              ROLE_ID === "2" ||
              ROLE_ID === "9")
        );
      } else if (statusId === 1) {
        // default ทั้งหมด
        result = [...dataArr];
      } else if (statusId === 4) {
        result = result.filter(
          (item) =>
            item.PROCESS_ID === 1 &&
            (item.customer_property_list?.length > 0 ||
              item.guarantor_property_list?.length > 0)
        );
      } else if (statusId === 5) {
        result = result.filter(
          (item) =>
            (item.PROCESS_ID === 4 || item.PROCESS_ID === 5) &&
            (item.customer_property_list?.length > 0 ||
              item.guarantor_property_list?.length > 0)
        );
      } else if (statusId === 6) {
        result = result.filter(
          (item) =>
            item.PROCESS_ID === 3 &&
            (item.customer_property_list?.length > 0 ||
              item.guarantor_property_list?.length > 0)
        );
      }
    }

    if (datePickerJudge && datePickerJudge.length === 2) {
      const start = dayjs(datePickerJudge[0]).startOf("day").valueOf();
      const end = dayjs(datePickerJudge[1]).endOf("day").valueOf();

      result = result.filter((item) => {
        // judge_date ในข้อมูลคุณเป็น ISO string => ให้ parse ตรง ๆ จะชัวร์กว่าใส่ format
        const date = dayjs(item?.judge_date).valueOf();
        return date >= start && date <= end;
      });
    } else if (datePickerInvestigate && datePickerInvestigate.length === 2) {
      // <<< ค้นหาตามวันที่ "สืบทรัพย์" จากทั้ง 2 list >>>
      const start = dayjs(datePickerInvestigate[0]).startOf("day").valueOf();
      const end = dayjs(datePickerInvestigate[1]).endOf("day").valueOf();

      result = result.filter(
        (item) =>
          hasInvestigationInRange(item?.customer_property_list, start, end) ||
          hasInvestigationInRange(item?.guarantor_property_list, start, end)
      );
    }

    // -----------------
    // Update state
    // -----------------
    console.log("onQuery", result);

    if (result.length > 0) {
      setArrayTable(result);
      setTableLength(result.length);
    } else {
      message.error("ไม่พบข้อมูล");
      setArrayTable([]);
      setTableLength(0);
    }
  };

  const columns = [
    {
      title: "ลำดับ",
      dataIndex: "key",
      key: "key",
      align: "center",
      width: "10%",
      render: (text, object, key) => key + 1,
      sorter: {
        compare: (a, b) => a.key - b.key,
        multiple: 5,
      },
    },
    {
      title: "เลขที่สัญญา",
      dataIndex: "CONTNO",
      key: "CONTNO",
      align: "center",
      render: (text, record) => (
        <Link
          onClick={() => {
            setIsModal(true);
            setDataRecord(record);
          }}
        >
          {record.CONTNO ? record.CONTNO : null}
        </Link>
      ),
    },
    {
      title: "ชื่อ-นามสกุล",
      dataIndex: "CUSTOMER_TNAM",
      key: "CUSTOMER_TNAM",
      align: "center",
      render: (text, record) => (
        <>
          {record.CUSTOMER_TNAME ? record.CUSTOMER_TNAME : null}{" "}
          {record.CUSTOMER_FNAME ? record.CUSTOMER_FNAME : null}{" "}
          {record.CUSTOMER_LNAME ? record.CUSTOMER_LNAME : null}
        </>
      ),
    },
    {
      title: "สถานะสืบทรัพย์",
      align: "center",
      render: (record) => <>{renderInvestigate(record)}</>,
    },
    {
      title: "วันที่เจอทรัพย์ล่าสุด",
      align: "center",
      render: (record) => <>{renderDateInvestiGateAsset(record)}</>,
    },
    {
      title: "สถานะการยึด",
      align: "center",
      render: (record) => <>{renderProcessStatus(record)}</>,
    },
    {
      title: "วันที่พิพากษา",
      align: "center",
      render: (record) => <>{renderDateJudge(record)}</>,
    },
    ...(ROLE_ID === "1" || ROLE_ID === "2" || ROLE_ID === "3" || ROLE_ID === "4"
      ? [
          {
            title: "เจ้าของคดี",
            align: "center",
            render: (record) => <>{record?.LAWYER_NNAME}</>,
          },
        ]
      : []),
  ];

  return (
    <>
      <Card>
        <Row>
          <Col span={"12"} style={{ textAlign: "start", marginBottom: "10px" }}>
            <Input
              placeholder="ค้นหาสัญญา"
              onChange={search}
              enterButton
              style={{
                width: 200,
                marginRight: 10,
              }}
              value={searchInput}
              size="large"
            />
            <Select
              placeholder="เลือกสถานะ"
              optionFilterProp="value"
              popupMatchSelectWidth={false}
              onChange={(value) => onChangeSelectStatus(value)}
              style={{
                width: "auto",
              }}
              size="large"
              value={statusId}
            >
              {renderOpteionStatus()}
            </Select>
          </Col>
          <Col span={"12"} style={{ textAlign: "end", marginBottom: "10px" }}>
            <Space direction="horizontal" size={8}>
              <Tooltip
                title={advanceSearch ? "ซ่อนตัวกรอง" : "แสดงตัวกรอง"}
                arrow={mergedArrow}
              >
                {!advanceSearch ? (
                  <DownSquareOutlined
                    style={{ fontSize: 20, color: "blue", marginTop: 4 }}
                    onClick={toggle} // antd ส่งค่า checked มาให้
                  />
                ) : (
                  <UpSquareOutlined
                    style={{ fontSize: 20, color: "blue", marginTop: 4 }}
                    onClick={toggle} // antd ส่งค่า checked มาให้
                  />
                )}
              </Tooltip>
              <Button
                icon={<ReloadOutlined />}
                onClick={() => {
                  setSearchInput(null);
                  setStatusId(null);
                  setDatePickerInvestigate(null);
                  setDatePickerJudge(null);
                }}
                style={{
                  color: "red",
                  borderRadius: "8px",
                  fontWeight: "bold",
                  boxShadow: "0px 4px 6px rgba(0, 0, 0, 0.1)",
                }}
                loading={loading}
              >
                ล้าง
              </Button>
              <Button
                type="primary"
                icon={<SearchOutlined />}
                size="large"
                style={{
                  borderRadius: "8px",
                  boxShadow: "0px 4px 6px rgba(0, 0, 0, 0.1)",
                  fontWeight: "bold",
                  background: "linear-gradient(135deg, #667eea, blue)",
                  border: "none",
                }}
                onClick={onQueryData}
                loading={loading}
              >
                ค้นหา
              </Button>
            </Space>
          </Col>
          <Col>
            {advanceSearch ? (
              <Col span={24} style={{ textAlign: "start" }}>
                <Space
                  direction="vertical"
                  size={8}
                  style={{ marginRight: 10 }}
                >
                  <Typography.Text strong>
                    ค้นหาจากวันที่พิพากษา
                  </Typography.Text>
                  <ThaiRangePicker
                    value={datePickerJudge}
                    onChange={onChangeJudgeDate}
                    size="large"
                  />
                </Space>

                <Space direction="vertical" size={8}>
                  <Typography.Text strong>ค้นหาจากวันเจอทรัพย์</Typography.Text>

                  <ThaiRangePicker
                    value={datePickerInvestigate}
                    onChange={onChangeInvestigateDate}
                    size="large"
                  />
                </Space>
              </Col>
            ) : null}
          </Col>
        </Row>
      </Card>
      <Card>
        <Spin spinning={loading} size="large" tip=" Loading... ">
          <Row>
            <Col span={"24"} style={{ textAlign: "end", marginBottom: "10px" }}>
              <PrinterOutlined
                style={{
                  fontSize: "40px",
                  color: "blue",
                  cursor: "pointer",
                }}
                key="print"
                onClick={() => {
                  createAndDownloadExcel();
                }}
              />
            </Col>
            <Col span={"24"}>
              <Table
                size="small"
                columns={columns}
                dataSource={arrayTable}
                scroll={{ x: 850 }}
                footer={() => <p>จำนวนสัญญาทั้งหมด {tableLength}</p>}
                expandable={{
                  expandedRowRender: (record) => (
                    <p style={{ margin: 0 }}>
                      {(ROLE_ID === "1" ||
                        ROLE_ID === "3" ||
                        ROLE_ID === "4") &&
                      record.PROCESS_ID === STATUS_PROCESS_PROGRESS ? (
                        <Tooltip
                          placement="bottom"
                          title="คลิกเพื่อสร้างบันทึกการยึด !"
                          arrow={mergedArrow}
                        >
                          <Button
                            name="create"
                            style={{
                              boxShadow: "0 4px 3px",
                              marginRight: "10px",
                              fontSize: "14px",
                              color: "blue",
                            }}
                            onClick={() => {
                              setIsModalCreate(true);
                              setDataRecord(record);
                              setStatusAction(STATUS_PROCESS_PROGRESS);
                            }}
                          >
                            <FormOutlined
                              style={{ color: "blue", fontSize: "16px" }}
                            />
                            สร้างรายงานการยึด
                          </Button>
                        </Tooltip>
                      ) : (ROLE_ID === "1" ||
                          ROLE_ID === "3" ||
                          ROLE_ID === "4") &&
                        record.PROCESS_ID === STATUS_PROCESS_SUCCESSFUL ? (
                        <Tooltip
                          placement="bottom"
                          title="คลิกเพื่อสร้างบันทึกการยึด !"
                          arrow={mergedArrow}
                        >
                          <Button
                            name="create"
                            style={{
                              boxShadow: "0 4px 3px",
                              marginRight: "10px",
                              fontSize: "14px",
                              color: "orange",
                            }}
                            onClick={() => {
                              setIsModalCreate(true);
                              setDataRecord(record);
                              setStatusAction(STATUS_PROCESS_PROGRESS);
                            }}
                          >
                            <FormOutlined
                              style={{ color: "orange", fontSize: "16px" }}
                            />
                            สร้างรายงานการยึดเพิ่ม
                          </Button>
                        </Tooltip>
                      ) : ((ROLE_ID === "1" ||
                          ROLE_ID === "3" ||
                          ROLE_ID === "4") &&
                          record.PROCESS_ID === STATUS_PROCESS_PROCESS) ||
                        record.PROCESS_ID === STATUS_PROCESS_PROCESS_PAYMENT ? (
                        <Tooltip
                          placement="bottom"
                          title="คลิกเพื่อเพิ่มรายงานบันทึกการยึด !"
                          arrow={mergedArrow}
                        >
                          <Button
                            name="create"
                            style={{
                              boxShadow: "0 4px 3px",
                              marginRight: "10px",
                              fontSize: "14px",
                              color: "green",
                            }}
                            onClick={() => {
                              setIsModalCreate(true);
                              setDataRecord(record);
                              setStatusAction(STATUS_PROCESS_PROCESS);
                            }}
                          >
                            <SyncOutlined
                              style={{ color: "green", fontSize: "16px" }}
                            />
                            อัพไฟล์บักทึกการยึด
                          </Button>
                        </Tooltip>
                      ) : null}
                      {ROLE_ID === "1" && (
                        <Tooltip
                          placement="bottom"
                          title="คลิกเพื่อแก้ไขคำพิพากษา !"
                          arrow={mergedArrow}
                        >
                          <Button
                            name="edit"
                            style={{
                              boxShadow: "0 4px 3px",
                              marginRight: "10px",
                              fontSize: "14px",
                              color: "orange",
                            }}
                            onClick={() => {
                              setIsModalEdit(true);
                              setDataRecord(record);
                            }}
                          >
                            <EditOutlined
                              style={{ color: "orange", fontSize: "16px" }}
                            />
                            แก้ไขคำพิพากษา
                          </Button>
                        </Tooltip>
                      )}
                    </p>
                  ),
                  rowExpandable: (record) =>
                    record.customer_property_list?.length > 0 ||
                    record.guarantor_property_list?.length > 0 ||
                    ROLE_ID === "1",
                  // userId === record.LAWYER_ID,
                  expandedRowKeys, // เก็บ state ของ row ที่ขยาย
                  onExpand, // ฟังก์ชันที่ควบคุมการขยาย
                }}
                rowKey="key"
              />
            </Col>
          </Row>
        </Spin>
      </Card>
      {isModal ? (
        <DetailModal open={isModal} close={setIsModal} dataRec={dataRecord} />
      ) : null}
      {isModalCreate ? (
        <ReportSeize
          open={isModalCreate}
          close={setIsModalCreate}
          dataDefualt={dataRecord}
          funcUpdateStatus={handleUpdateData}
          status={statusAction}
        />
      ) : null}
      {isModalEdit ? (
        <EditJudgement
          open={isModalEdit}
          close={setIsModalEdit}
          dataDefualt={dataRecord}
          funcUpdateStatus={handleUpdateData}
        />
      ) : null}
    </>
  );
};

const MainEnforcement = MotionHoc(Main);
export default MainEnforcement;
